import actions from 'netxcore@netx/core-notification/actions';

import {icon} from '@fortawesome/fontawesome-svg-core';
import {faComment} from '@fortawesome/pro-regular-svg-icons';

import {extendBackboneActions} from '@netx/core/utils/extendBackboneActions';

const iconOpts = {classes: ['fa-fw']};
const icons = {
	faComment: icon(faComment, iconOpts).html,
};

// Extend actions defined in core file
let newActions = extendBackboneActions(actions, [
	{
		event: 'notifications:routed',
		icon: icons.faComment,
		route: 'notifications',
	},
]);

export default newActions;
